import type {
    ProfileNavigationItemProps,
    ShorthandCollection,
} from '@archipro-design/aria';
import { CheckboxBlankLine, CheckboxFill } from '@archipro-design/icons';
import type { useSearchFilters } from '~/modules/search/hook/use-search-filters';

/**
 * Builds ProfileNavigation filter chips from active search filters for mobile title sections.
 */
export const createNavigationFilters = (
    searchFilters: ReturnType<typeof useSearchFilters>,
    items: ShorthandCollection<ProfileNavigationItemProps>,
) => {
    const { filterBarFilters, updateFilter } = searchFilters;
    filterBarFilters?.forEach(
        ({ filterKey, label, checked, disabled, props, newState }) => {
            items.push({
                key: `${filterKey}-tab`,
                iconBefore: checked ? <CheckboxFill /> : <CheckboxBlankLine />,
                children: label,
                onClick: () => updateFilter(filterKey, newState),
                selected: false,
                transparent: true,
                outlined: true,
                disabled,
                className: props.className,
            });
        },
    );
    return items;
};
